module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"freeGiftIncluded":"Free Gift Included"},"ar":{"freeGiftIncluded":"هدية مجانية مرفقة"}}')
  delete Component.options._Ctor
}
